// The API session token, sent as a bearer token. Local storage keeps it across tabs and browser
// restarts; the API enforces idle and absolute expiry on its side.
const SESSION_TOKEN_KEY = 'a6tr_session';

export const getSessionToken = (): string | undefined => {
	try {
		return localStorage.getItem(SESSION_TOKEN_KEY) ?? undefined;
	} catch {
		return undefined;
	}
};

export const setSessionToken = (token: string) => {
	try {
		localStorage.setItem(SESSION_TOKEN_KEY, token);
	} catch {
		// Storage unavailable (e.g. blocked): the user will be asked to sign in again.
	}
};

export const clearSessionToken = () => {
	try {
		localStorage.removeItem(SESSION_TOKEN_KEY);
	} catch {
		// Nothing to clear.
	}
};
